import { render, staticRenderFns } from "./alter-password.vue?vue&type=template&id=07470029&scoped=true"
import script from "./alter-password.vue?vue&type=script&lang=js"
export * from "./alter-password.vue?vue&type=script&lang=js"
import style0 from "./alter-password.vue?vue&type=style&index=0&id=07470029&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07470029",
  null
  
)

export default component.exports